import { Mediator } from '@spotahome/soyuz-mediator';
import { trans } from '@spotahome/soyuz/client';

import { CHANNELS } from '../utils/constants';

import { DSIcon } from '../../../base';

import ReducedLandlordInformation from '../ReducedLandlordInformation';

import styles from './LandlordVerifiedModal.module.scss';

const LandlordVerifiedModalContent = ({
  landlordInformation = null,
  landlordScoring = null
}) => {
  const showReducedLandlordInfo =
    landlordInformation?.type && landlordInformation != null;

  return (
    <div className={styles['landlord-verified-modal__body']}>
      <p>{trans('landlord_verified.modal.description')}</p>

      <div>
        <h5 className={styles['landlord-verified-modal__conditions-title']}>
          {trans('landlord_verified.modal.conditions1')}
        </h5>
        <ul className={styles['landlord-verified-modal__conditions-list']}>
          <li>{trans('landlord_verified.modal.conditions1.item1')}</li>
          <li>{trans('landlord_verified.modal.conditions1.item2')}</li>
          <li>{trans('landlord_verified.modal.conditions1.item3')}</li>
        </ul>
      </div>

      {showReducedLandlordInfo && (
        <ReducedLandlordInformation
          type={landlordInformation.type}
          joiningDate={landlordInformation.firstListingDate}
          listingsPublished={landlordInformation.listingsPublished}
          averageResponseTime={landlordInformation.averageResponseTime}
          languages={landlordInformation.languages}
          landlordScoring={landlordScoring}
        />
      )}
    </div>
  );
};

const openLandlordVerifiedModal = ({
  landlordInformation = null,
  landlordScoring = null
} = {}) => {
  Mediator.publish(CHANNELS.OPEN_INFORMATION_MODAL, {
    title: (
      <>
        <DSIcon name="verified" size="ml" />
        <br />
        {trans('landlord_verified.modal.title')}
      </>
    ),
    body: (
      <LandlordVerifiedModalContent
        landlordInformation={landlordInformation}
        landlordScoring={landlordScoring}
      />
    ),
    fullscreenOnMobile: true
  });
};

export default openLandlordVerifiedModal;
